import _defaults from 'lodash/defaults'

import { mergeResourceStores } from '../_helpers/ResourceStore'

export default {
  getters: {
    PackingInformation: (state, getters) => {
      return _defaults(
        getters.currentTripDashboardId
          ? getters.Trips[getters.currentTripDashboardId].packing_information
          : {},
        {
          'section-heading': 'Packing Information',
          'section-subheading':
            '<p>Below you will find all resources and links about packing for your trip.</p>',
          resource_stores: [
            {
              files: [],
              links: [],
              pages: [],
              title: 'Packing Information',
              tag: 'packing-information',
              order: 4
            }
          ]
        }
      )
    },
    PackingInformationMergedResourceStore: (state, getters) => {
      return mergeResourceStores(getters.PackingInformation.resource_stores, 'Packing Information')
    }
  }
}
